import gql from 'graphql-tag'
import {useMutation} from '@apollo/client'

const CREATE_SAVED_FILTER = gql`
  mutation createSavedFilter($saved_filter_name: String!, $saved_filter_values: [SavedFilterValueInput!]!) {
    createSavedFilter(saved_filter_name: $saved_filter_name, saved_filter_values: $saved_filter_values) {
      success
      message
      saved_filter_name
    }
  }
`

export default function useCreateSavedFilter() {
  const [createSavedFilter, {data, loading, error}] = useMutation(CREATE_SAVED_FILTER, {
    errorPolicy: 'all'
  })

  return {createSavedFilter, data, loading, error}
}
